import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconFile = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 16,
	fill: "none",
	viewBox: "0 0 17 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M4.253 1.333c-.737 0-1.332.6-1.332 1.334l-.007 10.666c0 .734.596 1.334 1.332 1.334h8.039c.736 0 1.338-.6 1.338-1.334v-8l-4.016-4H4.253zM8.938 6V2.333L12.619 6H8.938z"
	})
});
export default SvgIconFile;
